module.exports = __webpack_public_path__ + "static/img/9.183883c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/global/9.png
// module id = yU4A
// module chunks = 1